import { render, staticRenderFns } from "./ConfigTelnyx.vue?vue&type=template&id=1d7a6ca2&"
import script from "./ConfigTelnyx.vue?vue&type=script&lang=js&"
export * from "./ConfigTelnyx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports